import CryptoJS from "crypto-js";

import { SALT } from "@/constants";
import {
  SET_USER,
  REMOVE_USER,
  SET_PASSWORD_RESET_DATA
} from "@/store/mutation-types";

export default {
  [SET_USER](state, { name, id, group, token }) {
    state.token = token;
    state.name = CryptoJS.AES.encrypt(`${name}`, SALT).toString();
    state.id = CryptoJS.AES.encrypt(`${id}`, SALT).toString();
    state.group = CryptoJS.AES.encrypt(`${group}`, SALT).toString();
    state.authenticated = Boolean(token);
  },
  [REMOVE_USER](state) {
    state.name = null;
    state.id = null;
    state.group = null;
    state.token = null;
    state.authenticated = false;
  },
  [SET_PASSWORD_RESET_DATA](state, data) {
    state.passwordResetData = data;
  }
};
